import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, unref as _unref } from "vue"

import { ref, Ref, reactive } from 'vue'
import dayjs from 'dayjs'
import { boolean, string } from 'mathjs'
import { getNumber, exportHandle, formatNumber } from '@/utils/index'

export default /*#__PURE__*/_defineComponent({
  props: {
    tableData:{
        type:Array,
        default:[]
    },
    tableLoading:{
        type:Boolean,
        default:false
    },
    isFlows:{
        type:Boolean,
        default:false
    },
    showSelection:{
        type:Boolean,
        default:true
    },
    sortAble:{
        default:false
    },
    showTotal:{
        type:Boolean,
        default:false
    }
},
  emits: ['selectionChange','sort_change'],
  setup(__props, { expose, emit }) {

const props = __props

const tableHeight=window.innerHeight-480


const selectHandel=(val:any)=>{
    emit('selectionChange',val)
}

const flowsTableRef=ref()
const cashTableRef=ref()
const tableClear=()=>{
    flowsTableRef.value!.clearSelection()
}
const cashTableClear=()=>[
    cashTableRef.value!.clearSelection()
]
const sortChange=({column, prop, order}:any)=>{
    emit('sort_change',{prop,order})
}
const tablCclearSort=()=>{
    flowsTableRef.value.clearSort()
}
const cashTableClearSort=()=>{
    cashTableRef.value.clearSort()
}
const getRowKey=(row:any)=>{
    return row.id||""
}
const getSummaries=(param:any)=>{
   const { columns, data } = param;
      let sums:any = [];
      columns.forEach((column:any, index:any) => {
        if (index === 1) {
          sums[index] = "合计";
          return;
        } else if (column.property == "actualPaymentAmount"||column.property == "paypalPaymentAmount"||column.property == "cloudPaymentAmount"||column.property == "payoneerPaymentAmount") {
          //如果是经费（正常的加减法）
          const values = data.map((item:any) => Number(item[column.property]));
          if (!values.every((value:any) => isNaN(value))) {
            sums[index] = values.reduce((prev:any, curr:any) => {
              const value = Number(curr);
              var sum = 0;
              if (!isNaN(value)) {
                sum = Number(Number(prev) + Number(curr)).toFixed(2);
                return sum;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += " ";
          }
        }
      });
      return sums;
}
expose({
    tableClear,
    cashTableClear,
    tablCclearSort,
    cashTableClearSort
})

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (!__props.isFlows)
    ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        key: 0,
        "summary-method": getSummaries,
        "show-summary": __props.showTotal,
        onSortChange: sortChange,
        ref_key: "flowsTableRef",
        ref: flowsTableRef,
        height: tableHeight,
        "row-key": (row)=>row.id,
        onSelectionChange: _cache[0] || (_cache[0] = (val)=>selectHandel(val)),
        class: "mt-10 mb-10",
        data: __props.tableData,
        border: "",
        style: {"width":"1000%"}
      }, {
        default: _withCtx(() => [
          (__props.showSelection)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                type: "selection",
                width: "55",
                "reserve-selection": true
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            prop: "company",
            label: "付款公司",
            width: "90",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "resourceId",
            sortable: __props.sortAble,
            label: "译员ID",
            width: "100"
          }, null, 8, ["sortable"]),
          _createVNode(_component_el_table_column, {
            prop: "payMethod",
            label: "支付方式",
            width: "90",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "accountNumber",
            label: "账号",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "beneficiaryName",
            label: "收款单位或人员全称",
            width: "105",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "payCurrency",
            label: "支付币种",
            width: "60",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "actualPaymentAmount",
            sortable: __props.sortAble,
            label: "支付金额",
            width: "110",
            align: "right",
            "show-overflow-tooltip": ""
          }, null, 8, ["sortable"]),
          _createVNode(_component_el_table_column, {
            prop: "paypalPaymentAmount",
            label: "paypal支付译员金额",
            width: "100",
            align: "right",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "payoneer支付译员金额",
            prop: "payoneerPaymentAmount",
            "show-overflow-tooltip": "",
            align: "right",
            width: "110"
          }),
          _createVNode(_component_el_table_column, {
            prop: "cloudPaymentAmount",
            label: "云账户支付译员金额",
            width: "100",
            align: "right",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "beneficiaryCardId",
            label: "收款人身份证号",
            width: "105",
            "show-overflow-tooltip": ""
          })
        ]),
        _: 1
      }, 8, ["show-summary", "row-key", "data"])), [
        [_directive_loading, __props.tableLoading]
      ])
    : _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        key: 1,
        onSortChange: sortChange,
        height: tableHeight-50,
        ref_key: "cashTableRef",
        ref: cashTableRef,
        "row-key": (row)=>row.id,
        onSelectionChange: _cache[1] || (_cache[1] = (val)=>selectHandel(val)),
        data: __props.tableData,
        border: "",
        class: "mt-10 mb-10",
        style: {"width":"10000%"}
      }, {
        default: _withCtx(() => [
          (__props.showSelection)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                type: "selection",
                width: "55",
                "reserve-selection": true
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            prop: "accountName",
            label: "账户简称",
            width: "120",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "collectionAt",
            label: "日期",
            width: "120",
            "show-overflow-tooltip": "",
            formatter: (row)=>_unref(dayjs)(row.collectionAt).format('YYYY-MM-DD HH:mm:ss')
          }, null, 8, ["formatter"]),
          _createVNode(_component_el_table_column, {
            prop: "receiptCurrency",
            label: "收款币别",
            width: "90",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "receiptAmount",
            sortable: __props.sortAble,
            label: "收款金额",
            width: "110",
            "show-overflow-tooltip": ""
          }, null, 8, ["sortable"]),
          _createVNode(_component_el_table_column, {
            prop: "costTo",
            label: "收付方名称",
            width: "95",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "companyAlias",
            label: "公司简称",
            width: "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "costToAccount",
            label: "收付方账号",
            width: "150"
          }),
          _createVNode(_component_el_table_column, {
            prop: "summary",
            label: "银行摘要",
            width: "200"
          }),
          _createVNode(_component_el_table_column, {
            prop: "paymentType",
            label: "款项类型",
            width: "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "remarks",
            label: "备注",
            width: "200"
          })
        ]),
        _: 1
      }, 8, ["height", "row-key", "data"])), [
        [_directive_loading, __props.tableLoading]
      ])
}
}

})